import { render, staticRenderFns } from "./OrdersRD.vue?vue&type=template&id=2204a573"
import script from "./OrdersRD.vue?vue&type=script&lang=js"
export * from "./OrdersRD.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports